/**
 * Canonical report option constants and shared dropdown option arrays.
 * Kept minimal and UI-focused — no API logic here.
 *
 * Usage by context:
 *   - `reportOptions`  — MyTeams page & SearchUBTProjects page
 *   - `pipReportOptions` — ProjectDetails (PIP) page
 */

export const TEAM_SUMMARY_OPTION_ID = "team_summary";
export const TEAM_SUMMARY_OPTION_VALUE = "team_summary";

export const TEAM_DETAILS_OPTION_ID = "team_details";
export const TEAM_DETAILS_OPTION_VALUE = "team_details";

export const EXPORT_TEST_OF_CHANGE_ID = "export_test_of_change_csv";
export const EXPORT_TEST_OF_CHANGE_VALUE = "export_test_of_change_csv";

export const EXPORT_TEST_DATA_OPTION_ID = "export_test_data_csv";
export const EXPORT_TEST_DATA_OPTION_VALUE = "export_test_data_csv";

export const EXPORT_GL_DATA_OPTION_ID = "export_gl_data_csv";
export const EXPORT_GL_DATA_OPTION_VALUE = "export_gl_data_csv";

export const EXPORT_UBT_DETAILS_OPTION_ID = "export_ubt_details_csv";
export const EXPORT_UBT_DETAILS_OPTION_VALUE = "export_ubt_details_csv";

/**
 * PIP / ProjectDetails-page-specific export option.
 * Exports the Test of Change report for the currently-viewed team.
 */
export const EXPORT_TOC_PIP_OPTION_ID = "export_toc_pip_csv";
export const EXPORT_TOC_PIP_OPTION_VALUE = "export_toc_pip_csv";

export const EXPORT_ROLES_CSV_OPTION_ID = "export_roles_csv";
export const EXPORT_ROLES_CSV_OPTION_VALUE = "export_roles_csv";

export const EXPORT_PIP_HISTORY_CSV_OPTION_ID = "export_pip_history_csv";
export const EXPORT_PIP_HISTORY_CSV_OPTION_VALUE = "export_pip_history_csv";

export const reportOptions = [
  {
    id: TEAM_SUMMARY_OPTION_ID,
    label: "Team Summary",
    value: TEAM_SUMMARY_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: TEAM_DETAILS_OPTION_ID,
    label: "Team Details",
    value: TEAM_DETAILS_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: EXPORT_GL_DATA_OPTION_ID,
    label: "Export GL Data (CSV)",
    value: EXPORT_GL_DATA_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
    {
    id: EXPORT_TEST_OF_CHANGE_ID,
    label: "Export Test of Change (CSV)",
    value: EXPORT_TEST_OF_CHANGE_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: EXPORT_TEST_DATA_OPTION_ID,
    label: "Export Test Data (CSV)",
    value: EXPORT_TEST_DATA_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: EXPORT_UBT_DETAILS_OPTION_ID,
    label: "Export UBT Details (CSV)",
    value: EXPORT_UBT_DETAILS_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: EXPORT_ROLES_CSV_OPTION_ID,
    label: "Export Roles (CSV)",
    value: EXPORT_ROLES_CSV_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: EXPORT_PIP_HISTORY_CSV_OPTION_ID,
    label: "Export PIP History (CSV)",
    value: EXPORT_PIP_HISTORY_CSV_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
];

/**
 * Dropdown options for the ProjectDetails (PIP) page.
 * Shown under the "Team Reports & Exports" button on the team summary panel.
 */
export const pipReportOptions = [
  {
    id: EXPORT_TOC_PIP_OPTION_ID,
    label: "Export Test of Change (CSV)",
    value: EXPORT_TOC_PIP_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
];

/**
 * Report options for the DetailsContainer (Projects page) dropdown.
 * Includes Team Summary, Team Details (PDF), and Export PIP History (CSV).
 */
export const projectDetailReportOptions = [
  {
    id: TEAM_SUMMARY_OPTION_ID,
    label: "Team Summary",
    value: TEAM_SUMMARY_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: TEAM_DETAILS_OPTION_ID,
    label: "Team Details",
    value: TEAM_DETAILS_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: EXPORT_PIP_HISTORY_CSV_OPTION_ID,
    label: "Export PIP History (CSV)",
    value: EXPORT_PIP_HISTORY_CSV_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
];

/**
 * Report options for the SearchUBTProjects page dropdown.
 */
export const searchProjectReportOptions = [
  {
    id: TEAM_SUMMARY_OPTION_ID,
    label: "Team Summary",
    value: TEAM_SUMMARY_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: TEAM_DETAILS_OPTION_ID,
    label: "Team Details",
    value: TEAM_DETAILS_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
  {
    id: EXPORT_PIP_HISTORY_CSV_OPTION_ID,
    label: "Export PIP History (CSV)",
    value: EXPORT_PIP_HISTORY_CSV_OPTION_VALUE,
    iconPath: "/assets/images/printer-outline.svg",
  },
];
